import { render, staticRenderFns } from "./UploadCert.vue?vue&type=template&id=31076384&scoped=true&"
import script from "./UploadCert.vue?vue&type=script&lang=js&"
export * from "./UploadCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31076384",
  null
  
)

export default component.exports